export const incidentRosterKeys = {
  base: ['incidentRoster'] as const,
  byIncident: (incidentId: string) =>
    [...incidentRosterKeys.base, incidentId] as const,
  draftBase: ['draftRosterForIncident'] as const,
  draftByIncident: (incidentId: string) =>
    [...incidentRosterKeys.draftBase, incidentId] as const,
} as const;
